import { useLayoutEffect, useRef, type ReactNode } from 'react'
import clsx from 'clsx'
import { markTextTruncation, observeTextTruncation } from '../utils/textTruncation'

/**
 * One line of text that, when it doesn't fit, fades out over its last
 * --text-fade-width instead of ending in an ellipsis (`.text-fade-truncate`).
 * Text that fits keeps a crisp end. For names (menu rows, headers), not
 * values, where a faded number could pass for a complete one.
 */
export default function FadeTruncatedText({
  children,
  className,
}: {
  children: ReactNode
  className?: string
}) {
  const ref = useRef<HTMLSpanElement>(null)

  useLayoutEffect(() => {
    const element = ref.current
    return element ? observeTextTruncation(element) : undefined
  }, [])
  // New text can overflow a box that keeps its size.
  useLayoutEffect(() => {
    if (ref.current) markTextTruncation(ref.current)
  }, [children])

  return (
    <span ref={ref} className={clsx('text-fade-truncate', className)}>
      {children}
    </span>
  )
}
